import config from '@app/config'

export const getUserCurrency = () =>
  config.regionalSettings?.currencyId || undefined
